var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "d-flex flex-wrap ma-n2"
  }, [_c('v-btn', {
    attrs: {
      "icon": "",
      "large": "",
      "color": "#1877f2",
      "target": "_blank",
      "href": `https://www.facebook.com/sharer.php?u=${_vm.encoded.url}&title=${_vm.encoded.title}&description=${_vm.encoded.description}&hashtag=%23Ellacard`,
      "disabled": _vm.disabled
    },
    on: {
      "click": function ($event) {
        return _vm.record('facebook');
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "large": ""
    },
    domProps: {
      "innerHTML": _vm._s(_vm.mdiFacebook)
    }
  })], 1), _c('v-btn', {
    attrs: {
      "icon": "",
      "large": "",
      "color": "#007bb5",
      "target": "_blank",
      "href": `https://linkedin.com/sharing/share-offsite/?url=${_vm.encoded.url}`,
      "disabled": _vm.disabled
    },
    on: {
      "click": function ($event) {
        return _vm.record('linkedin');
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "large": ""
    },
    domProps: {
      "innerHTML": _vm._s(_vm.mdiLinkedin)
    }
  })], 1), !_vm.link ? _c('v-btn', {
    attrs: {
      "icon": "",
      "large": "",
      "color": "#bd081c",
      "target": "_blank",
      "href": `http://pinterest.com/pin/create/button/?url=${_vm.encoded.url}&title=${_vm.encoded.title}&description=${_vm.encoded.description}&media=${_vm.encoded.media}`,
      "disabled": _vm.disabled || !_vm.encoded.media
    },
    on: {
      "click": function ($event) {
        return _vm.record('pinterest');
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "large": ""
    },
    domProps: {
      "innerHTML": _vm._s(_vm.mdiPinterest)
    }
  })], 1) : _vm._e(), _c('v-btn', {
    attrs: {
      "icon": "",
      "large": "",
      "color": "#ff4500",
      "target": "_blank",
      "href": `https://reddit.com/submit?url=${_vm.encoded.url}&title=${_vm.encoded.title}`,
      "disabled": _vm.disabled
    },
    on: {
      "click": function ($event) {
        return _vm.record('reddit');
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "large": ""
    },
    domProps: {
      "innerHTML": _vm._s(_vm.mdiReddit)
    }
  })], 1), _c('v-btn', {
    attrs: {
      "icon": "",
      "large": "",
      "color": "#000",
      "target": "_blank",
      "href": `https://x.com/intent/tweet?url=${_vm.encoded.url}&text=${_vm.encoded.description}&hashtags=Ellacard`,
      "disabled": _vm.disabled
    },
    on: {
      "click": function ($event) {
        return _vm.record('twitter');
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "large": ""
    },
    domProps: {
      "innerHTML": _vm._s(_vm.iconPathX)
    }
  })], 1), _c('v-btn', {
    attrs: {
      "icon": "",
      "large": "",
      "disabled": _vm.disabled
    },
    on: {
      "click": function ($event) {
        _vm.record('link');
        _vm.copyToClipboard(_vm.shareURL, {
          msg: 'Link copied'
        });
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "large": ""
    },
    domProps: {
      "innerHTML": _vm._s(_vm.mdiLinkVariant)
    }
  })], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }